import { Button } from '@pets-ui/Button/Button'
import { PasswordSuccess as PasswordSuccessIcon } from '@pets-ui/icons'
import { SvgIcon } from '@pets-ui/SvgIcon/SvgIcon'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useWpLayout } from '@pets-ui/useWpLayout/useWpLayout'
import { VStack } from '@pets-ui/VStack/VStack'
import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { wordPressNavigate } from '../../../utils/wordPressRoute'
import { useContextCosign } from '../../useContextCosign'
import { CardLogin } from '../CardLogin'
import { PasswordSuccessType } from '../login/types'
import { Service } from '../Service'

export function PasswordSuccess() {
  const { t } = useTranslation()
  const { title } = useContextCosign()
  useWpLayout({ footer: false })

  const handleClickBack = () => {
    wordPressNavigate('/my-account/')
  }

  const passwordSuccessType: PasswordSuccessType = Number(Cookies.get('password_success'))

  const display = {
    [PasswordSuccessType.REGISTER]: {
      title: t('login.passwordCreatedSuccess'),
      content: t('login.returnToLogin'),
    },
    [PasswordSuccessType.CHANGE]: {
      title: t('login.passwordChangedSuccess'),
      content: t('login.returnToLogin'),
    },
  }

  useEffect(() => {
    if (passwordSuccessType === undefined) {
      wordPressNavigate('/my-account/')
    }
  }, [passwordSuccessType])

  return (
    <CardLogin>
      <Helmet>
        <title>
          {display[passwordSuccessType].title}
          {' '}
          -
          {' '}
          {title}
        </title>
      </Helmet>
      <VStack gap={4} alignItems="center">
        <SvgIcon fontSize={120} color={colors.green400}><PasswordSuccessIcon /></SvgIcon>
        <Text variant="h4">{display[passwordSuccessType].title}</Text>
        <Button onClick={handleClickBack} fullWidth>{display[passwordSuccessType].content}</Button>
      </VStack>
      <Service />
    </CardLogin>
  )
}
